import React from "react";
import { Project } from "../types";

interface ProjectsSectionProps {
  projects: Project[];
}

const ProjectsSection: React.FC<ProjectsSectionProps> = ({ projects }) => {
  return (
    <div className="projects-list">
      {projects.map((project, index) => (
        <div key={index} className="project-item">
          <div className="project-content">
            <div className="project-header">
              <h3 className="project-title">
                {project.url ? (
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                    title={`Visit website`}
                  >
                    {project.name}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "5px", fontSize: "0.8rem" }}
                    ></i>
                  </a>
                ) : (
                  <span className="">{project.name}</span>
                )}
              </h3>
            </div>

            <p className="project-description">{project.description}</p>
            <div className="project-technologies">
              {project.technologies.map((tech, techIndex) => (
                <span key={techIndex} className="tech-tag">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectsSection;
